module.exports = __webpack_public_path__ + "img/Poker_Chip_Black.4a26e602.svg";